// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cobX","newExpiryDate":"styles_newExpiryDate__3IS-B","footer":"styles_footer__1xXbJ"};